var render = function render(){var _vm=this,_c=_vm._self._c;return _c('company-table')
}
var staticRenderFns = []

export { render, staticRenderFns }